import { render } from "./bottomMenu.vue?vue&type=template&id=551e46f0"
import script from "./bottomMenu.vue?vue&type=script&lang=js"
export * from "./bottomMenu.vue?vue&type=script&lang=js"

import "./bottomMenu.vue?vue&type=style&index=0&id=551e46f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__